import { useNavigate } from 'react-router-dom';
import './Patents.css';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './footer.js';
import Navbar from './Navbar.js';
// import teacher from './teacher.jpeg';
// import doctor from './doctor.png';
// import analyst from './analyst.png';
// import lawyer from './lawyer.png';
import doctor from './doctor.mp4';
import teacher from './teacher.mp4';
import analyst from './analyst.mp4';
import lawyer from './lawyer.mp4';

const PatentsPage = () => {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const [highlighted, setHighlighted] = useState('');

  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      setHighlighted(id);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }
    const clearHighlight = () => {
      setHighlighted('');
    };
    document.addEventListener('click', clearHighlight);
    return () => {
      document.removeEventListener('click', clearHighlight);
    };
  }, [hash]);

  return (
    <div className="patent-page-container">
      <Navbar />
      <main className="patent-content-wrapper">
        <div className="patent-research-content">
          <h1>Cnyda Dynamics Patent Division</h1>
          <p>
            At the forefront of scientific innovation, our company is pioneering a new generation of proprietary patents and intellectual property built upon advanced mathematics, scientific research, artificial intelligence, and large-scale data analytics. Through years of deep research and breakthrough discoveries, we have developed a novel cognitive brain architecture that enables AI systems to reason, learn, and make decisions with unprecedented precision and reliability. This foundational innovation serves as the core engine behind a portfolio of transformative technologies designed to solve complex real-world challenges across healthcare, finance, education, and enterprise intelligence.
            Among our groundbreaking innovations are an AI Doctor capable of delivering evidence-based medical reasoning with a strong focus on eliminating hallucinations, an AI-powered Insider Trading Risk Quantification system designed to help regulators and market participants identify potential risks across companies and sectors, and next-generation AI Data Analyst and AI Teacher platforms that provide personalized, human-like guidance and support. By combining advanced cognitive intelligence with domain-specific expertise, our technologies are redefining how people interact with knowledge, make decisions, and access expert-level assistance, creating a new era of trustworthy, intelligent, and highly personalized AI solutions.

          </p>
        </div>

        <div className="patent-card-container_research">
          <div 
            id="doctor" 
            className={`patent-card_research ${highlighted === 'doctor' ? 'patent-highlight-glow' : ''}`}>
             <video 
              src={doctor} 
              className="patent-card-image_research" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
            <div className="patent-card-content_research">
              <h1 className="patent-card-title_research">AI Doctor:</h1>
              <p className="patent-card-text_research">
                The company has developed an AI Doctor avatar first of its kind in the World which never hallucinates and works based on evidence.
              </p>
              <button className="patent-card-btn_research" onClick={(e) => { e.stopPropagation(); handleNavigation('/doctor'); }} >Read More</button>
            </div>
          </div>
        </div>

        <div className="patent-card-container_research">
          <div 
            id="teacher" 
            className={`patent-card_research ${highlighted === 'teacher' ? 'patent-highlight-glow' : ''}`}>
            <video 
              src={teacher} 
              className="patent-card-image_research" 
              autoPlay 
              loop 
              muted 
              playsInline 
            />
            <div className="patent-card-content_research">
              <h1 className="patent-card-title_research">AI Teacher:</h1>
              <p className="patent-card-text_research">
                Powered by our patented Cognitive Brain technology, our AI Teacher delivers personalized, adaptive, and human-like learning experiences that enhance understanding, engagement, and academic success.
              </p>
              <button className="patent-card-btn_research" onClick={(e) => { e.stopPropagation(); handleNavigation('/teacher'); }} >Read More</button>
            </div>
          </div>
        </div>

        <div className="patent-card-container_research">
          <div 
            id="analyst" 
            className={`patent-card_research ${highlighted === 'analyst' ? 'patent-highlight-glow' : ''}`}>
             <video 
              src={analyst} 
              className="patent-card-image_research" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
            <div className="patent-card-content_research">
              <h1 className="patent-card-title_research">AI Analyst:</h1>
              <p className="patent-card-text_research">
                Using our patented Brain technology, Analyst AI transforms data and text into actionable intelligence, seamlessly performing everything from statistical analysis and predictive modeling to advanced agentic AI workflows and machine learning.
              </p>
              <button className="patent-card-btn_research" onClick={(e) => { e.stopPropagation(); handleNavigation('/analyst'); }} >Read More</button>
            </div>
          </div>
        </div>

        <div className="patent-card-container_research">
          <div 
            id="lawyer" 
            className={`patent-card_research ${highlighted === 'lawyer' ? 'patent-highlight-glow' : ''}`}>
             <video 
              src={lawyer} 
              className="patent-card-image_research" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
            <div className="patent-card-content_research">
              <h1 className="patent-card-title_research">AI Lawyer:</h1>
              <p className="patent-card-text_research">
                Powered by our patented Cognitive Brain technology, our AI Lawyer delivers precise, efficient legal assistance that enhances accessibility and reduces costs.
              </p>
              <button className="patent-card-btn_research" onClick={(e) => { e.stopPropagation(); handleNavigation('/lawyer'); }} >Read More</button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PatentsPage;